<script>
    import {push} from 'svelte-spa-router';
    import Header from './Header.svelte';
    export let params = {}

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    let dash_token = params.t
	if (dash_token != '1') {
		dash_token = getCookie("m_dash_token")
		if (dash_token == '' || dash_token == null) {
			dash_token = '1';
		}
	}

	let dash_token_link = dash_token;
	if (dash_token_link != '1') {
		dash_token_link = '2'
	}

    let mebot_id = params.id
    mebot_id = getCookie('m_id');
	if (mebot_id == '') {
		mebot_id = 0;
	}

    let stat_mebot_id = params.m_id

    let mebot_trips = [];
	let mebot_trips_tmp = [];
	let mebot_attr = [];

	function setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function set_section(name) {
        setCookie("section", name, 1)
    }

	set_section('news');

    async function getMebotNews(mebot_id) {

		const res = await fetch(
			"https://api.forever.today/?method=get_mebot_news",
			{
				method: "POST",
				body: JSON.stringify({
					dash_token,
					mebot_id
				}),
			}
		);

		const json = await res.json();
		let runners = json.data.trips;

		mebot_attr = json.data.attr;
		mebot_trips_tmp = [];
		let info_str = '';
		let land = null;

		for (const runner of runners) {

			land = null;
			if (runner.info != null) {
				info_str = runner.info

				if (runner.land_img != null) {
					land = runner.land_img
				}
			} else {
				info_str = runner.eff + '%'
			}
			mebot_trips_tmp.push({
				id: runner.m_id,
				img: runner.mebot_img_url,
				land_img: land,
				land_file_id: runner.land_file_id,
				sparkles: runner.sparkles,
				eff: runner.eff,
				info: info_str,
				time_ago: runner.time_ago,
				ts: runner.ts,
			});
		}
		//mebot_trips = mebot_trips_tmp.slice(0, 14);
		mebot_trips = mebot_trips_tmp;

	}

    getMebotNews(0);

	let y;

</script>

<Header
    header_mebot_id = { mebot_id }
    header_dash_token = { dash_token }
/>

<!--<center>
    <div style="width: 300px; overflow: hidden">
        <iframe title="iframe" src="/ifeed.html" width="307" height="800"
            scrolling="yes" style="width: 307px; height: 800px; border:none;"
            allowtransparency="true">
            Mebots content            
        </iframe>
    </div>
</center>-->

<center>
<div class="main1">
    <table width=340px valign=middle border=0>
    {#each mebot_trips as trip, i}
    <tr height=65px>
    <td align=left valign=top width=50px style="padding-top: 2px; padding-bottom: 4px;">
        {#if trip.land_img != null}
            <div class="message question no_tap_zoom" on:click={ () => { push('/habitat/2/' + trip.land_file_id) } }> &nbsp; <img src="{trip.land_img}" class="no_tap_zoom land_sm" style="user-select: none;" width=32px height=32px alt="Land42"></div>
        {:else}
            <div class="message question no_tap_zoom" on:click={ () => { push('/stats/2/' + mebot_id + '/' + trip.id) } }> &nbsp; <img src="{trip.img}" class="no_tap_zoom" style="user-select: none;" width=38px height=38px alt="Mebot"></div>
        {/if}
    </td>
    <td width=160px valign=top style="padding-bottom: 10px;"> <span class="vitals-mid text-glow-blueish">{@html trip.info }</span> </td>
    <td width=50px align=right valign=top on:click={ () => { if (trip.ts > 0) { push('/i/' + dash_token_link + '/' + trip.ts) } } }> <span class="vitals-small text-glow-gray" class:text-hl={ (trip.ts > 0) } >{trip.time_ago}</span> &nbsp;</td>
    </tr>
    {/each}
    </table>
    <br><br><br><br><br><br>
</div>
</center>


<style>

.main1 {
    border-radius: 20px;
    background-color: rgba(0, 24, 39, 0.6);
    background-color: linear-gradient(rgba(0, 24, 39, 0.6), rgba(0,0,0,0.6));
    height: 700px;
    width: 370px;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: left;
    padding: 0px;
    overscroll-behavior: auto;
    border: none;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}

.main1::-webkit-scrollbar {
  display: none;
}

.main {
		background-color: rgba(0, 0, 0, 0.465);
		overflow-x: auto;
		overflow-y: auto;
		background-image: url("/img/nyc_bg_sm.jpeg");
		background-position: center; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: cover; /* Resize the background image to cover the entire container */
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		touch-action: manipulation;
		overflow: auto;
		-webkit-appearance: none;
		overscroll-behavior: auto;
    height: 4000px;  
    margin-top: 50px;
}

.vitals-small {
	font-size: 12px;
}

.vitals-mid {
	font-size: 14px;
}

.text-glow-blueish {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: hsl(185, 40%, 70%);
}

.text-glow-gray {
	text-shadow: 0 0 10px rgb(192 219 255 / 75%),
		0 0 32px rgb(65 120 255 / 88%);
	font-family: arial;
	color: rgba(255, 255, 255, 0.465);
}

.text-hl {
	color: rgba(255, 255, 255, 0.724);
}

.land_sm {
	border-radius: 10px;
}

</style>